import { useTranslation } from "react-i18next";
import StatusType from "enums/StatusType";
import { Chip, StatusGlyph } from "@outpave/ds";
import type { ChipTone } from "@outpave/ds";

interface RenderAccountStatusProps {
  accountStatus: string;
  isDeactivateRequested: boolean;
}

const statusMapping: any = {
  [StatusType.PENDING]: {
    name: "Pending",
    chipTone: "neutral",
  },
  [StatusType.PENDING_REVIEW]: {
    name: "Pending Review",
    chipTone: "neutral",
  },
  [StatusType.ACTIVE]: {
    name: "Active",
    chipTone: "positive",
  },
  [StatusType.INACTIVE]: {
    name: "Inactive",
    chipTone: "warning",
  },
  [StatusType.DEACTIVATED]: {
    name: "Deactivated",
    chipTone: "warning",
  },
  default: {
    name: "Unknown Status",
    chipTone: "neutral",
  },
};

export const RenderAccountStatus: React.FC<RenderAccountStatusProps> = ({
  accountStatus,
  isDeactivateRequested,
}) => {
  const { t } = useTranslation();

  let statusKey = accountStatus;

  if (accountStatus === StatusType.INACTIVE && isDeactivateRequested) {
    statusKey = StatusType.DEACTIVATED;
  }

  const { name, chipTone } =
    statusMapping[statusKey as StatusType] || statusMapping.default;
  const tone: ChipTone = chipTone;

  // StatusGlyph is looked up by the untranslated `name`, so the glyph is right
  // in every locale while the label renders translated.
  return (
    <Chip
      tone={tone}
      size="sm"
      leading={<StatusGlyph status={name} tone={tone} />}
    >
      {t(name)}
    </Chip>
  );
};
